import { render, staticRenderFns } from "./IconBanner.vue?vue&type=template&id=1ada26d1&scoped=true"
import script from "./IconBanner.vue?vue&type=script&lang=js"
export * from "./IconBanner.vue?vue&type=script&lang=js"
import style0 from "./IconBanner.vue?vue&type=style&index=0&id=1ada26d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada26d1",
  null
  
)

export default component.exports